module.exports = __webpack_public_path__ + "media/marketing_area/BrushStrokes-Grey-c60a2b92.jpg";